export default {
      id: "vdab-usage",
      viewBox: "0 0 196 96",
      url: "../../assets/" + "sprite.svg#vdab-usage",
      toString: function () {
        return this.url;
      }
    }